module.exports = function(app) {
	'use strict';
	app.service('uncoveredDependentModal', ['modal', 'employee', function(modal, employee) {

		 function getUncoveredDependentNames(ds) {
			return ds.filter(
				function(d) { return d.memberCoverages.length === 0; }
			).map(
				function(d) { return employee.getDisplayName(d); }
			);
		}

		this.launch = function(employeeData, modalScope, deferred) {
			modalScope.dependentNames = getUncoveredDependentNames(employeeData.dependents);
			modalScope.doTheOK = deferred.resolve;
			modalScope.lolNah = deferred.reject;

			modal.open({
				template: require('factories/uncoveredDependentModal.html'),
				scope: modalScope,
				onClose: modalScope.lolNah,
				classes: 'epr-standard-modal'
			});
		};
	}]);
};
